export const addCustomerToSelection = (customerData, customerToAdd) => {
  const exisitingCustomer = customerData.find(
    (customer) => customer.id === customerToAdd.id
  );

  if (exisitingCustomer) {
    return customerData;
  }

  return [
    ...customerData,
    {
      ...customerToAdd,
      messageId: null,
      status: 'not sent',
      emailStatus: 'not sent',
      textStatus: 'not sent',
    },
  ];
};

export const removeCustomerFromSelection = (customerData, customerToRemove) => {
  const exisitingCustomer = customerData.find(
    (customer) => customer.id === customerToRemove.id
  );

  if (exisitingCustomer) {
    if (exisitingCustomer.status !== 'not sent') {
      return customerData;
    }
  }

  return customerData.filter((customer) => customer.id !== customerToRemove.id);
};

export const updateCustomerMessageStatus = (
  customerData,
  customerMessageData
) => {
  return customerData.map((customer) =>
    customer.id === customerMessageData.id
      ? {
          ...customer,
          messageId: customerMessageData.messageId,
          emailStatus: customerMessageData.emailStatus,
          textStatus: customerMessageData.textStatus,
        }
      : customer
  );
};
